<script lang="ts">
  import { DirectusImage, Preset } from '@do/svelte-directus-images';

  import { AvatarPlaceholder } from '@shared/ui/avatar-placeholder';
  import { Content } from '@shared/ui/content';
  import { Icon } from '@shared/ui/icon';

  import type { ArtAsset } from '@entities/art-asset';

  export let review: NonNullable<ArtAsset['curator_review']>;

  $: curator = review.curator;
</script>

<div class="bg-orange-gradient dark:bg-green-gradient md:p-6' rounded-lg p-5">
  <Icon name="quotes" classes="w-6 h-6 mb-2.5" />

  <Content blocks="{review.description?.blocks}" containerClasses="md:text-base font-medium mb-5 md:mb-6" />

  <div class="flex gap-4 md:items-center lg:min-w-80 lg:items-start">
    <a
      href="/curator-{curator.id}-{curator.slug}/"
      class="flex h-[50px] w-[50px] shrink-0 items-center justify-center overflow-hidden rounded-full"
    >
      <DirectusImage
        imageData="{curator?.photo}"
        pictureSizes="{{
          default: '50px',
        }}"
        presetKeys="{Preset.Mini}"
        alt="{curator.first_name} {curator.last_name}"
        loading="lazy"
        imgClasses="object-cover shrink-0 overflow-hidden w-[50px] h-[50px]"
      >
        <AvatarPlaceholder slot="default-placeholder" rounded="{false}" name="{curator.first_name}" classes="text-lg" />
      </DirectusImage>
    </a>

    <div>
      <a
        href="/curator-{curator.id}-{curator.slug}/"
        class="dark:hover:text-default-320 hover:text-default-600 block shrink-0 text-lg font-medium transition-colors"
      >
        {curator.first_name}
        {curator.last_name}
      </a>

      <a
        href="/curator-{curator.id}-{curator.slug}/"
        class="dark:hover:text-default-320 hover:text-default-600 text-base transition-colors"
      >
        {curator.position}
      </a>
    </div>
  </div>
</div>
